<template>
  <div class="bottom-navigation">
    <div class="nav-container">
      <router-link 
        to="/user/home" 
        class="nav-item"
        :class="{ 'active': isActive('/user/home') }"
      >
        <div class="nav-icon">
          <i class="mdi mdi-home"></i>
        </div>
        <span class="nav-label">Beranda</span>
      </router-link>

      <router-link 
        to="/user/event" 
        class="nav-item"
        :class="{ 'active': isActive('/user/event') }"
      >
        <div class="nav-icon">
          <i class="mdi mdi-calendar"></i>
        </div>
        <span class="nav-label">Event</span>
      </router-link>

      <router-link 
        to="/user/campaign" 
        class="nav-item"
        :class="{ 'active': isActive('/user/campaign') }"
      >
        <div class="nav-icon">
          <i class="mdi mdi-bullhorn"></i>
        </div>
        <span class="nav-label">Campaign</span>
      </router-link>

      <router-link 
        to="/user/points" 
        class="nav-item"
        :class="{ 'active': isActive('/user/points') }"
      >
        <div class="nav-icon">
          <i class="mdi mdi-star"></i>
        </div>
        <span class="nav-label">Points</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileBottomNavigation",
  data() {
    return {
      userId: null
    };
  },
  computed: {
    canAccessCampaign() {
      // Only allow user ID 10828 to access Campaign
      return this.userId === 11379;
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    
    fetchUserId() {
      const userDatas = this.$getUserInfo();
      this.userId = userDatas.sub?.user_id;
    }
  },
  mounted() {
    this.fetchUserId();
  }
};
</script>

<style scoped>
.bottom-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e9ecef;
  z-index: 1000;
  display: none;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.5rem 0;
  max-width: 100%;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: #6c757d;
  transition: all 0.3s ease;
  border-radius: 12px;
  min-width: 60px;
  position: relative;
}

.nav-item:hover {
  color: #495057;
}

.nav-item.active {
  color: white;
  background: #ffc107;
}

.nav-item.active .nav-icon {
  transform: scale(1.1);
}

.nav-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
  transition: transform 0.3s ease;
}

.nav-icon i {
  font-size: 1.4rem;
}

.nav-label {
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  line-height: 1;
}

/* Show on mobile */
@media (max-width: 768px) {
  .bottom-navigation {
    display: block;
  }
}

/* Add padding to body when bottom nav is visible */
@media (max-width: 768px) {
  body {
    padding-bottom: 80px;
  }
}

/* Animation for active state */
.nav-item.active::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: #e0a800;
  border-radius: 50%;
}

/* Ripple effect on tap */
.nav-item::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 193, 7, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
}

.nav-item:active::after {
  width: 40px;
  height: 40px;
}
</style>